import { render, staticRenderFns } from "./CatalogTable.vue?vue&type=template&id=40b40be4&scoped=true"
import script from "./CatalogTable.vue?vue&type=script&lang=js"
export * from "./CatalogTable.vue?vue&type=script&lang=js"
import style0 from "./CatalogTable.vue?vue&type=style&index=0&id=40b40be4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b40be4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Tables/CatalogTable.vue
// module id = 1464
// module chunks = 31